import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import locale from 'date-fns/locale/en-US';
import { postManualPreadviceTransactionsCreateRequestActionCreator } from '../redux/actions/ManualPreadviceTransactionsCreateActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';
import {
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
} from '../../../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';
import {
  getInboundImpcsOfSingleOperator,
  getLeftPostalOperatorsCodesOnly,
  getOutboundImpcsOfSingleOperator,
} from '../../../../../../common/user/redux/selectors/UserDataSelectors';
import {
  getGlobalPresetImpc,
  getGlobalPresetOperator,
} from '../../../../../../common/selection-criteria/global-preset/redux/selectors/GlobalPresetPerAssetTypeSelectors';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class ManualPreadviceTransactionsCreateDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: props.row.row.comments,
      departureDateTime: moment(props.row.row.departureDate).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
      impcFrom: this.props.globalImpc.includes(props.row.row.impc) ? props.row.row.impc : 'Select IMPC',
      impcTo: props.row.row.impcTo,
      operatorFrom: this.props.globalOperator.includes(props.row.row.operator) ? props.row.row.operator : 'Select Operator',
      operatorTo: props.row.row.operatorTo,
      plannedArrivalDateTime: moment(props.row.row.arrivalDate).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
      quantity: props.row.row.quantity,
    };
    this.handleNewOutboundOperator = this.handleNewOutboundOperator.bind(this);
    this.handleNewOutboundIMPC = this.handleNewOutboundIMPC.bind(this);
    this.handleNewInboundOperator = this.handleNewInboundOperator.bind(this);
    this.handleNewInboundIMPC = this.handleNewInboundIMPC.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleDepartureDate = this.handleDepartureDate.bind(this);
    this.handleArrivalDate = this.handleArrivalDate.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, props.row.row.operator);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.operatorFrom !== prevState.operatorFrom) {
      this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.operatorFrom);
    }

    if (this.state.operatorTo !== prevState.operatorTo) {
      this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.operatorTo);
    }
  }

  isFormValid = () => !(this.state.quantity === ''
    || (moment(this.state.departureDateTime).isAfter(this.state.plannedArrivalDateTime))
    || this.state.quantity === undefined
    || this.state.departureDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === 'Invalid date'
    || this.state.impcFrom === 'Select IMPC'
    || this.state.impcTo === 'Select IMPC'
    || this.state.operatorTo === undefined
    || this.state.operatorFrom === 'Select Operator'
    || this.state.impcTo === 'Select...')

  handleNewOutboundOperator(selectedOption) {
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      operatorFrom: selectedOption.value,
      impcFrom: 'Select IMPC',
    });
  }

  handleNewOutboundIMPC(selectedOption) {
    this.setState({
      impcFrom: selectedOption.value,
    });
  }

  handleNewInboundOperator(selectedOption) {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      operatorTo: selectedOption.value,
      impcTo: 'Select IMPC',
    });
  }

  handleNewInboundIMPC(selectedOption) {
    this.setState({
      impcTo: selectedOption.value,
    });
  }

  handleQuantity(e) {
    this.setState({
      quantity: e.target.value,
    });
  }

  handleComments(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  handleDepartureDate(date) {
    this.setState({
      departureDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  handleArrivalDate(date) {
    this.setState({
      plannedArrivalDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmCreate() {
    await this.props.postManualPreadviceTransactionsCreateRequestActionCreator(
      this.props.appContext,
      this.state.comments,
      this.state.departureDateTime,
      this.state.impcFrom,
      this.state.impcTo,
      this.state.operatorFrom,
      this.state.operatorTo,
      this.state.plannedArrivalDateTime,
      this.state.quantity,
    );
    this.props.closeDialog();
    this.props.refreshTransactions();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Create Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Outbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorFrom}
                    placeholder={this.state.operatorFrom}
                    options={this.props.operatorFromOptions}
                    onChange={this.handleNewOutboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Outbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcFrom}
                    placeholder={this.state.impcFrom}
                    options={this.mapImpcListToSelectOptions(this.props.impcFromList)}
                    onChange={this.handleNewOutboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorTo}
                    placeholder={this.state.operatorTo}
                    options={this.props.operatorToOptions}
                    onChange={this.handleNewInboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcTo}
                    placeholder={this.state.impcTo}
                    options={this.mapImpcListToSelectOptions(this.props.impcToList)}
                    onChange={this.handleNewInboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Departure date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline-dep"
                        value={this.state.departureDateTime}
                        onChange={this.handleDepartureDate}
                        maxDate={this.state.plannedArrivalDateTime}
                        maxDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Arrival date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        variant="inline"
                        autoOk
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline-arr"
                        value={this.state.plannedArrivalDateTime}
                        onChange={this.handleArrivalDate}
                        minDate={this.state.departureDateTime}
                        minDateTime={this.state.departureDateTime}
                        minDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Quantity
                </td>
                <td className="selected-impc">
                  <Input type="number" value={this.state.quantity} onChange={this.handleQuantity} />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Comment
                </td>
                <td className="selected-impc">
                  <Input
                    value={this.state.comments}
                    onChange={this.handleComments}
                    maxLength={45}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmCreate}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

ManualPreadviceTransactionsCreateDialog.propTypes = {
  row: PropTypes.shape({
    row: PropTypes.shape({
      arrivalDate: PropTypes.instanceOf(Date),
      comments: PropTypes.string,
      departureDate: PropTypes.instanceOf(Date),
      id: PropTypes.string,
      impc: PropTypes.string,
      impcFrom: PropTypes.string,
      impcTo: PropTypes.string,
      operator: PropTypes.string,
      operatorFrom: PropTypes.string,
      operatorTo: PropTypes.string,
      quantity: PropTypes.string,
    }),
  }),
  appContext: PropTypes.objectOf(PropTypes.shape),
  impcToList: PropTypes.arrayOf(PropTypes.string),
  impcFromList: PropTypes.arrayOf(PropTypes.string),
  operatorFromOptions: PropTypes.arrayOf(PropTypes.object),
  operatorToOptions: PropTypes.arrayOf(PropTypes.object),
  postManualPreadviceTransactionsCreateRequestActionCreator: PropTypes.func,
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  getImpcsOfSingleOutboundOperatorRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  globalOperator: PropTypes.arrayOf(PropTypes.string),
  globalImpc: PropTypes.arrayOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    impcToList: getInboundImpcsOfSingleOperator(state),
    impcFromList: getOutboundImpcsOfSingleOperator(state),
    operatorFromOptions: getLeftPostalOperatorsCodesOnly(state),
    operatorToOptions: getLeftPostalOperatorsCodesOnly(state),
    globalOperator: getGlobalPresetOperator(state),
    globalImpc: getGlobalPresetImpc(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postManualPreadviceTransactionsCreateRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManualPreadviceTransactionsCreateDialog);
